import { useCallback, useEffect, useRef, useState } from "react";
import { unstable_batchedUpdates } from "react-dom";

export interface BusyAction {
	busy: string;
	run: (key: string, action: () => void | Promise<void>) => void;
}

export function useBusyAction(): BusyAction {
	const [busy, setBusy] = useState('');
	const running = useRef(false);
	const mounted = useRef(true);

	useEffect(() => () => {
		mounted.current = false;
	}, []);

	const run = useCallback((key: string, action: () => void | Promise<void>) => {
		if (running.current) {
			return;
		}
		running.current = true;
		setBusy(key);
		const done = () => {
			running.current = false;
			if (mounted.current) {
				setBusy('');
			}
		};
		requestAnimationFrame(() => setTimeout(() => unstable_batchedUpdates(() => {
			let result: void | Promise<void>;
			try {
				result = action();
			} catch (error) {
				done();
				throw error;
			}
			if (result instanceof Promise) {
				result.finally(done);
			} else {
				done();
			}
		}), 0));
	}, []);

	return { busy, run };
}
